// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2AtEY","footerInner":"style_footerInner__2Ffo_","logo":"style_logo__BZM7g"};